/* eslint-disable jsx-a11y/tabindex-no-positive */
import { useEffect } from "react";
import { CloseIcon } from "components/close-icon";
import { Portal } from "components/portal";
import { Backdrop } from "./backdrop-style";
import { ModalWrapper } from "./custom-modal.style";

interface ICustomModal {
   width?: string;
   isDashboard?: string;
   children: React.ReactNode;
   handleClose: () => void;
   visible: boolean;
   noPadding?: boolean;
   isWhite?: boolean;
   maxHeight?: string;
}

const CustomModal = ({
   handleClose,
   children,
   width,
   visible,
   noPadding,
   isWhite,
   maxHeight,
}: ICustomModal) => {
   useEffect(() => {
      if (visible) {
         document.body.style.overflow = "hidden";
      } else {
         document.body.style.overflow = "auto";
      }
   }, [visible]);

   return (
      <Portal selector="#portal">
         <Backdrop visible={visible} onClick={handleClose} />
         <ModalWrapper
            mxh={maxHeight}
            visible={visible}
            style={{ width, padding: noPadding ? 0 : "" }}
         >
            <CloseIcon handleClose={handleClose} className="icon" isWhite={isWhite} />
            <div>
               <div style={{ height: "100%" }}>{children}</div>
            </div>
         </ModalWrapper>
      </Portal>
   );
};

export { CustomModal };
